import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/close.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
  tooltipInfo?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '24 24',
  },
  title: {
    color: '#3393F3',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  closeBtn: {
    float: 'right',
  },
  subTitle: {
    fontSize: 12,
    color: '#3393F3',
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    marginBottom: 12,
    '& input': {
      float: 'right',
    },
  },
  mobileHeader: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  typeHead: {
    fontSize: 14,
    color: 'rgba(24, 24, 24, 1)',
    fontWeight: 600,
  },
  typeDetail: {
    fontWeight: 400,
    fontSize: 14,
    '& p': {
      marginTop: 10,
      lineHeight: '20px',
    },
  },
})

const PoDTooltipModal = ({
  open,
  setOpen,
  handleClose,
  tooltipInfo,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <div className={classes.content}>
            {isMobile && (
              <div className={classes.header}>
                <div className={classes.mobileHeader}>
                  <span className={classes.title}>{tooltipInfo.title}</span>
                  <input
                    className={classes.closeBtn}
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
                {tooltipInfo.subTitle && (
                  <span className={classes.subTitle}>
                    {' '}
                    ({tooltipInfo.subTitle})
                  </span>
                )}
              </div>
            )}

            {!isMobile && (
              <div className={classes.header}>
                <span className={classes.title}>{tooltipInfo.title}</span>
                {tooltipInfo.subTitle && (
                  <span className={classes.subTitle}>
                    {' '}
                    ({tooltipInfo.subTitle})
                  </span>
                )}
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            <div className={classes.detailContent}>
              {/* <p className={classes.typeHead}>Credit stress measure </p> */}
              <div className={classes.typeDetail}>
                <p>
                  This is a percentage measure of the probability a firm will
                  default over the next 12 months. The higher the percentage the
                  worse the credit outlook for the firm is and vis-a-versa the
                  lower the better the credit situation.
                </p>
                <p>
                  This credit stress measure has been built using structural
                  structural models, however it has been trained looking at the
                  real world of how you would assess a company’s rating. This is
                  in contrast to most industry models which are built on very
                  sparsely populated default examples which are not a universal
                  reflection of credit risk. This allows for the credit stress
                  measure to operate as a proxy for a distance to rating
                  downgrade. The higher the percentage credit stress measure the
                  the more chance there is a of a subsequent ratings downgrade.
                </p>
                <p>
                  Financial institutions (Banks) have been notoriously difficult
                  to fit to this type of credit model given the complexity of
                  their balance sheets. This has been redefined in line with
                  recommendations from regulatory bodies such as the IMF. We use
                  risk weighted assets (RWA) as a way of assessing the credit
                  strength of banks which makes the credit stress measure a
                  strong proxy for a distance to capital stress a more important
                  measure than the credit rating. In relation to banks the
                  higher the credit stress measure percentage the higher the
                  capital stress they are facing. This is a unique innovation in
                  the industry.
                </p>
              </div>
            </div>

            <div className={classes.detailContent}>
              <p className={classes.typeHead}>Peer credit stress measure</p>
              <div className={classes.typeDetail}>
                <p>
                  To isolate out if the credit stress measure for a certain
                  company is idiosyncratic or not, we provide a sector,
                  geography peer credit stress measure. This allows you to
                  isolate out if this credit situation is individual to the
                  company or a sector wide occurrence. You can toggle on and off
                  the peer credit stress measure as an overlay on the chart.
                </p>
              </div>
            </div>

            <div className={classes.detailContent}>
              <p className={classes.typeHead}>Equity price</p>
              <div className={classes.typeDetail}>
                <p>
                  The inter play between credit and equities is a useful
                  relationship to observe, there is a toggle on and off to
                  overlay the equity price of the company against the credit
                  stress measure. This will allow you to have a 360 view of the
                  company, where you may see lead / lag or correlated
                  relationships between asset classes.
                </p>
              </div>
            </div>

            {!isMobile && (
              <>
                <div className={classes.detailContent}>
                  <p className={classes.typeHead}>Custom Peer Comparison</p>
                  <br />
                  <p className={classes.typeHead}>
                    What it is: This is the ability to compare credit stress
                    measures (CSM) between up to three different peer companies.
                    Click on the “+ Custom Peer Comparison symbol”, search for
                    the company you want to compare to the current company, this
                    will then plot as a comparative CSM on the below graph.
                  </p>
                  <br />
                  <p className={classes.typeHead}>Things to look out for:</p>
                  <div
                    className={classes.typeDetail}
                    style={{ marginLeft: '10px' }}
                  >
                    <p>
                      &#x2022; breakouts in CSM from issuers with similar OAS
                      spreads/ CDS prices
                    </p>
                    `&#x2022; long term trend reversals`
                    <p>&#x2022; sudden jumps/ dislocations</p>
                  </div>
                  <br />
                </div>
                <div className={classes.detailContent}>
                  <div className={classes.typeDetail}>
                    <p>
                      <b>Next best actions: </b>Utilise the ability in your
                      context to create competitive advantage in your process
                    </p>
                  </div>

                  <div
                    className={classes.typeDetail}
                    style={{ marginLeft: '10px' }}
                  >
                    <p className={classes.typeHead}>&#x2022; Buy Side </p>
                    <div
                      className={classes.typeDetail}
                      style={{ marginLeft: '20px' }}
                    >
                      <p>
                        &#8857; Identify relative value trades for issuers in
                        the same bond cohort to generate better returns at lower
                        risk
                      </p>
                      <p>
                        &#8857; Rotate capital into more liquid issues to
                        replicate benchmark performance at higher scale.
                      </p>
                      <p>
                        &#8857; Identify trends longitudinally and
                        cross-sectionally to optimise portfolio weights.
                      </p>
                    </div>
                  </div>

                  <div
                    className={classes.typeDetail}
                    style={{ marginLeft: '10px' }}
                  >
                    <p className={classes.typeHead}>&#x2022; Sell Side </p>
                    <div
                      className={classes.typeDetail}
                      style={{ marginLeft: '20px' }}
                    >
                      <p>
                        &#8857; Provide advisory for bespoke execution with
                        improvement in fundamental credit risk for clients
                      </p>
                      <p>
                        &#8857; Enhance trading desk PNL by enhancing relative
                        value tilt in inventory over 1-3 months
                      </p>
                      <p>
                        &#8857; Generate trade ideas for structured products
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(PoDTooltipModal)
